<template><section><h3>图表介绍</h3>
<p>Pie， 饼图。</p>
<h3>attrs</h3>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>clientRect</td>
<td>Object</td>
<td>{top,right,bottom,left,width,height}</td>
<td>设置了 width,heigh,优先与 bottom,right</td>
</tr>
<tr>
<td>startAngle</td>
<td>Number</td>
<td><code v-pre>Math.PI * -0.5</code></td>
<td>起始角度</td>
</tr>
<tr>
<td>endAngle</td>
<td>Number</td>
<td><code v-pre>Math.PI * 1.5</code></td>
<td>结束角度</td>
</tr>
<tr>
<td>radius</td>
<td>Number</td>
<td><code v-pre>0.8</code></td>
<td>外半径比例</td>
</tr>
<tr>
<td>innerRadius</td>
<td>Number</td>
<td><code v-pre>0</code></td>
<td>内半径比例</td>
</tr>
<tr>
<td>animation</td>
<td>Boolean,Object</td>
<td>{easing:'',duration}</td>
<td>动画配置</td>
</tr>
</tbody>
</table>
<h3>style</h3>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie()
pie.style(<span class="hljs-string">'text'</span>, { <span class="hljs-attr">color</span>: <span class="hljs-string">'#fff'</span> }
</code></pre>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>sector</td>
<td>面</td>
<td>扇形样式</td>
</tr>
<tr>
<td>text</td>
<td>文本</td>
<td>扇形上文字样式</td>
</tr>
<tr>
<td>guideline</td>
<td>线</td>
<td>指导线样式</td>
</tr>
<tr>
<td>guideText</td>
<td>文本</td>
<td>指导文字样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>